import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faCircleNotch, faWallet, faCreditCard, faArrowUpFromBracket, faBitcoinSign, faBank, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'

function PlanDeposit() {
  const { user } = useUser();
  const { state } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [activeTab, setActiveTab] = useState(localStorage.getItem('upgrade.type') || 'crypto');
  const savedplan = localStorage.getItem('upgrade.plan');
  const [plan, setPlan] = useState(state?.plan ?? savedplan);
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if(activeTab){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [activeTab]);

  const [fee, setFee] = useState(() => {return state?.fee ?? localStorage.getItem('withdraw.fee');});
  const [feeamount, setFeeAmount] = useState(() => {return state?.feeamount ?? localStorage.getItem('withdraw.feeamount');});

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Make a Deposit</h5>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/plandeposit" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Method</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Deposit Details</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Payment Proof</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit4" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h5 className="mb-0" style={{fontWeight:'900'}}>Select Deposit Method</h5>
                              <div className="row">
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" onClick={() => setActiveTab('crypto')} style={{border:activeTab == 'crypto' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faBitcoinSign} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Cryptocurrency</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: 0%</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>50-30 minutes</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Popular</div>
                                  </div>
                                </div>
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" style={{border:activeTab == 'bank' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faBank} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Bank Transfer</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: $5</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>1-3 business days</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Unavailable</div>
                                  </div>
                                </div>
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" style={{border:activeTab == 'paypal' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faWallet} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Paypal</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: 3.5%</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Instant</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Unavailable</div>
                                  </div>
                                </div>
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" style={{border:activeTab == 'skrill' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faWallet} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Skrill</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: 2.5%</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Instant</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Unavailable</div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                    <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                    <Link to="/plandeposit1" state={{plan:plan, type:activeTab}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => { 
                                      localStorage.setItem('upgrade.plan', plan);
                                      localStorage.setItem('upgrade.type', activeTab);
                                      localStorage.setItem('withdraw.feeamount', feeamount);
                                      localStorage.setItem('withdraw.fee', fee);
                                    }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default PlanDeposit